var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.004999911412596703 0 61.900001525878906 74.71491241455078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "af85583cb-48ec-42c3-99ec-704f0e1cfdd1",
    x1: -386.7,
    y1: 388.53,
    x2: -386.7,
    y2: 354.33,
    gradientTransform: "matrix(2.18 0 0 2.18 875.35 -773.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.95 0L9.06 21.88a30.95 30.95 0 1 0 43.77 0zm0 33l5.38 5.38a7.61 7.61 0 1 1-10.76 0z",
    fill: "url(#af85583cb-48ec-42c3-99ec-704f0e1cfdd1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 9.9L15.67 28.49a21.61 21.61 0 1 0 30.56 0l-5.38-5.39 3.3-3.3 5.38 5.38a26.28 26.28 0 1 1-37.17 0L30.95 6.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.85 16.5L22.27 35.09a12.28 12.28 0 1 0 17.37 0l-5.39-5.39 3.3-3.3 5.38 5.38a16.95 16.95 0 1 1-24 0L37.55 13.2z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7111d9a055145a3c8cc0069e5779ab81.svg";
export { ForwardRef as ReactComponent };